var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.percentage == 100)?_c('el-progress',{attrs:{"stroke-width":6,"percentage":_vm.percentage,"color":_vm.colors,"status":"success"}}):_c('el-progress',{attrs:{"stroke-width":6,"percentage":_vm.percentage,"color":_vm.colors}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }